<template>
    <div class="w-full bg-primary">
        <!-- eslint-disable-next-line tailwindcss/no-custom-classname -->
        <div class="countdown-fill size-full origin-right bg-[#dddddd]" />
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";

    const props = defineProps<{
        /** The value determines how much of the bar should display.
         * The value should be between [0, 1]. */
        progress: number;
        /** Provide how often progress updates, so that we can keep the movement of the progress bar seamless.
         * At high tick rates occasional jumps occur, which cannot be prevented. */
        tickRateMs?: number;
    }>();

    const scaleX = computed(() => props.progress);
    const transitionDuration = computed(() => (props.tickRateMs ? `${props.tickRateMs}ms` : "0ms"));
</script>

<style scoped>
    /* dynamic v-bind values require <style>, not implementable with Tailwind */
    .countdown-fill {
        transform: scaleX(v-bind(scaleX));
        transition: transform v-bind(transitionDuration) linear;
    }
</style>
